import React from "react";

function DeleteIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="33"
      viewBox="0 0 35 33"
    >
      <g
        id="Group_27178"
        data-name="Group 27178"
        transform="translate(6558 23203)"
      >
        <rect
          id="Rectangle_11971"
          data-name="Rectangle 11971"
          width="35"
          height="33"
          transform="translate(-6558 -23203)"
          fill="#596970"
          opacity="0"
        />
        <path
          id="Path_18518"
          data-name="Path 18518"
          d="M20.75,7H27V9.5H24.5V25.75A1.25,1.25,0,0,1,23.25,27H5.75A1.25,1.25,0,0,1,4.5,25.75V9.5H2V7H8.25V3.25A1.25,1.25,0,0,1,9.5,2h10a1.25,1.25,0,0,1,1.25,1.25Zm-10,6.25v7.5h2.5v-7.5Zm5,0v7.5h2.5v-7.5Zm-5-8.75V7h7.5V4.5Z"
          transform="translate(-6555 -23201)"
          fill="#596970"
        />
      </g>
    </svg>
  );
}

export default DeleteIcon;
